module.exports = __webpack_public_path__ + "static/media/Roxx-Racing-Logo-Background.df4ac607.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Roxx-Racing-Logo-Background.jpg
// module id = 39
// module chunks = 0